import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaIcon } from '../interfaces/sia-icon';
import { SiaLayout } from '../interfaces/sia-layout';
import { SiaHttpService } from '../services/http.service';
@Injectable({
  providedIn: 'root',
})
export class SiaLayoutApi {
  private httpService = inject(SiaHttpService);

  private readonly apiController: string = 'layout';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  // NON USA CACHE
  getLayouts() {
    return this.httpService.get(`${this.apiController}/layouts`, {}, '');
  }

  getLayout(layoutId: string): Promise<SiaLayout> {
    let params = new HttpParams();
    params = params.set('id', `${layoutId}`);
    return this.httpService.get(`${this.apiController}/layout`, { params }, '');
  }

  updateLayout(l: any) {
    return this.httpService.putCache(
      `${this.apiController}/layout`,
      l,
      'layouts',
      {},
      '',
    );
  }

  getIcons(): Promise<SiaIcon[]> {
    var options = {};
    return this.httpService.getCache(
      `${this.apiController}/get-icons`,
      options,
      'fa-icons',
      '',
    );
  }

  getMaterialIcons(): Promise<SiaIcon[]> {
    var options = {};
    return this.httpService.get(
      `${this.apiController}/get-material-icons`,
      options,
      '',
    );
  }
}
